import { render, staticRenderFns } from "./ArchiveArticles.vue?vue&type=template&id=643a8651&scoped=true"
import script from "./ArchiveArticles.vue?vue&type=script&lang=js"
export * from "./ArchiveArticles.vue?vue&type=script&lang=js"
import style0 from "./ArchiveArticles.vue?vue&type=style&index=0&id=643a8651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a8651",
  null
  
)

export default component.exports